import React, {useContext, useEffect, useMemo, useState} from "react"
import {Box, Flex, Heading, Text} from "@chakra-ui/react";
import RadarVocab from "../../graph/RadarVocab";
import {LOG} from "../../tools";
import LIST_ALL_TAG_ID_VOCAB, {getNameFromTagId, getTagInfoFromTagId, LIST_ALL_VOCAB} from "../tools";
import {HeaderSection} from "../../mainPage/HeaderSection";
import TagMenuSelect from "./TagMenuSelect";
import PersonalizedContentContext from "../../../context/PersonalizedContent";


const TagContentVocabViz = ({dataVocabs, name})=>{

    const datasetsRaw = useMemo(()=>{
        let dataset_raw_datainfo = {}
            if (dataVocabs!= null){
                dataVocabs.forEach((vocabValue)=>{
                const tag_id = vocabValue[0]
                const proportion = vocabValue[1]/10000
                const diff_ratio = vocabValue[2]/100
                dataset_raw_datainfo[tag_id] = {
                    "p":proportion,
                    "d":diff_ratio
                }
                })
            }
        return  [{label:name,jsonTagIdToData: dataset_raw_datainfo}]
    }, [dataVocabs])


    const {jsonTagVisible} = useContext(PersonalizedContentContext);
   const tagType = "V"
    const listTagJson = LIST_ALL_VOCAB
    const objectSetTagVisible = useMemo(()=>{
        return jsonTagVisible.hasOwnProperty(tagType)?
                        (jsonTagVisible[tagType].size>0?jsonTagVisible[tagType]:new Set(listTagJson.map(p => p.id)))
                                :new Set(listTagJson.map(p => p.id))
    }, [jsonTagVisible,listTagJson])
    const listTagJsonShown = useMemo(()=>{
        let listTagJsonShown_tmp =  listTagJson.filter((tagJson)=> objectSetTagVisible.has(tagJson.id))
        listTagJsonShown_tmp.sort((a,b) => {
            if (datasetsRaw[0].hasOwnProperty("jsonTagIdToData")){
                const diff_a = datasetsRaw[0]["jsonTagIdToData"].hasOwnProperty(a.id)?datasetsRaw[0]["jsonTagIdToData"][a.id]["d"]:0
            const diff_b = datasetsRaw[0]["jsonTagIdToData"].hasOwnProperty(b.id)?datasetsRaw[0]["jsonTagIdToData"][b.id]["d"]:0
            return diff_b - diff_a
            }else{return 0}
        })
        return listTagJsonShown_tmp
    }, [listTagJson,objectSetTagVisible,datasetsRaw])
    const listTagIdShown = useMemo(()=>{
        return listTagJsonShown.map(t => t.id)
    }, [listTagJsonShown])

    return <Box>
        <HeaderSection  text={"Les grandes thématiques"} flexGrowRight={18} />
        <Flex justifyContent={"flex-end"}><TagMenuSelect listTag={LIST_ALL_VOCAB} tagType={"V"} /></Flex>
        <Flex flexWrap={"wrap"} alignItems={"center"}>
            <Box width={["100%","100%","50%"]}>
                <Text fontWeight={"bold"}>
                    Sur les trois dernières semaines, l'activité concernant {name} abordait
                    </Text>
                    <Box>
                        {listTagJsonShown.map( (t) => {
                            let diff,prop
                            if (datasetsRaw[0].hasOwnProperty("jsonTagIdToData") && datasetsRaw[0]["jsonTagIdToData"].hasOwnProperty(t.id)){
                                diff = datasetsRaw[0]["jsonTagIdToData"][t.id]["d"]
                                prop = datasetsRaw[0]["jsonTagIdToData"][t.id]["p"]
                            }else{
                                diff = 0
                                prop = 0
                            }


                            return <TextVocabActivity vocabTag={t} diff={diff} prop={prop}/>
                        })}

                    </Box>

            </Box>
            <Box width={["100%","100%","50%"]}>
            <RadarVocab
                datasetsRaw = {datasetsRaw}
                listTagIdToKeep={listTagIdShown}
            />
        </Box>
        </Flex>

    </Box>
}
const json_weigth_color = {
    0:"text.50",
    1:"text.100",
    2:"text.200",
    3:"text.300"
}
const json_weigth_color_tag = {
    0:"bg.700",
    1:"bg.700",
    2:"bg.900",
    3:"text.50"
}
const json_weigth_fontsize = {
    0:"20px",
    1:"18px",
    2:"18px",
    3:"20px",
}
const TextVocabActivity = ({ vocabTag,diff,prop}) =>{

    const weightDiff = useMemo(()=>{
        if(diff>1){
            if(diff>2){
                return 3
            }
             return 2
        }else{
            if(diff<0.5){
                return 0
            }else{
                return 1
            }
        }
    }, [diff])
    const color = useMemo(()=>{
        return json_weigth_color[weightDiff]
    }, [weightDiff])

    const colorTag =json_weigth_color_tag[weightDiff]
    const fontSize = json_weigth_fontsize[weightDiff]
    const diff_str = <Text as={"span"} color={color} fontSize={fontSize} fontWeight={"bold"}>{diff}</Text>
    const prop_str =<Text as={"span"} fontWeight={"bold"}>{ Math.round((prop*100 + Number.EPSILON) * 1000) / 1000}% des tweets</Text>
    return <Box  mt={'7px'} mb={'7px'} p={1} fontSize={"15px"} fontFamily={"body"}
    borderLeftStyle={'solid'} borderLeftWidth={'5px'} borderLeftColor={"bg.700"}
    >
        {diff_str} fois {diff>=1?"plus":"moins"} la thématique <Text  as={"span"} bg={colorTag} p={"1px"} fontFamily={"heading"} fontWeight={"bold"} fontSize={'18px'} >{vocabTag.n}</Text> que la normale. Soit {prop_str}
    </Box>
}

export default TagContentVocabViz